module.exports = __webpack_public_path__ + "static/img/mtjz05.917d30e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/mtjz05.png
// module id = 57Jp
// module chunks = 11